import React from 'react';
import Navbar from './Navbar';

class Decision extends React.Component{
    constructor(props){
        super(props);   
        this.state={
            deciding:false,
            decided:false,
            decision:"Yes",
            meter:0,
            color: ""
        };
        this.Decide = this.Decide.bind(this);
    }
    sleep=(ms)=>{
        return new Promise(resolve => setTimeout(resolve, ms));
      }
    async Decide(){
        this.setState({decided:false});
        for(let i=0; i<101;i++){
            this.setState({meter:i});
            await this.sleep(i*0.5);
        }
        if(Math.round(Math.random())===1){
            this.setState({
                deciding:false,
                decided:true,
                decision:"Yes",
                color: "#D9F5BE"
            });
        }else{
            this.setState({
                deciding:false,
                decided:true,
                decision:"No",
                color: "#F8D9D5"
            })
        }
    }
    render(){
        if(this.state.decided){            
            return(
                <div className="pusher" style={{backgroundColor:this.state.color,height:"100vh"}}>
                <div className="ui vertical masthead center aligned segment">
                <Navbar active="decision" color=""/>
                <div className="ui text container">
                <h3 className="ui header" style={{marginTop:"8vh"}}>Decision Maker!</h3>
                <img src="/decider/images/decision.svg" alt="Clover" style={this.state.decision === "Yes" ? {width:"150px",transition:"all 0.5s", filter:"hue-rotate(40deg)"} : {width:"150px",transition:"all 0.5s", filter:"hue-rotate(300deg)"}} />
                <h1 className="ui header" style={{fontSize:"3em",marginTop:"0"}}>Decide Your Fate Here!</h1>
                <div onClick={this.state.deciding ? (e)=>{e.preventDefault()} : this.Decide} className={"ui huge button "+(this.state.deciding ? "disabeled" : "primary")}>{this.state.deciding ? "Calculating..." : "Calculate"}</div>
                <div className={"ui progress "+(this.state.meter === 0 ? "grey" : this.state.meter < 30 ? "red" : this.state.meter < 60 ? "yellow" : this.state.decision === "Yes" ? "green" : "red")}>
                    <div className="bar" style={this.state.meter === 0 ? {width:"100%", textAlign:"center"} : {width:Math.floor(this.state.meter)+"%"}}>
                        <div className="progress" style={this.state.meter === 0 ? {right:"",left:"43%"} : {}}>{this.state.meter === 0 ? "Press Calclulate!" : this.state.meter+"%"}</div>
                    </div>
                </div>
                        <div className={"ui huge statistic "}>
                            <div className="label">
                                You should choose
                            </div>
                            <div className="value">
                                {this.state.decision}
                            </div>
                        </div>
                        </div>
                </div>
                </div>
            );
        }else{
            return (
                <div className="pusher">
                <div className="ui vertical masthead center aligned segment" style={{borderBottom:"#fff"}}>
                <Navbar active="decision" color=""/>
                <div className="ui text container">
                <h3 className="ui header" style={{marginTop:"8vh"}}>Decision Maker</h3>
                <img src="/decider/images/decision.svg" className="ui loading icon" alt="Clover" style={{width:"150px",transition:"all 0.5s", filter:"grayscale(100)"}} />
                <h1 className="ui header" style={{fontSize:"3em",marginTop:"0"}}>Decide Your Fate Here!</h1>
                <div onClick={this.state.deciding ? (e)=>{e.preventDefault()} : this.Decide} className={"ui huge button "+(this.state.deciding ? "disabeled" : "primary")}>{this.state.deciding ? "Calculating..." : "Calculate"}</div>
                <div style={{margin:"1em 0 2.5em"}} className={"ui progress "+(this.state.meter === 0 ? "grey" : this.state.meter < 30 ? "red" : this.state.meter < 60 ? "yellow" : "green")}>
                    <div className="bar" style={this.state.meter === 0 ? {width:"100%", textAlign:"center"} : {width:Math.floor(this.state.meter)+"%"}}>
                        <div className="progress" style={this.state.meter === 0 ? {right:"",left:"43%"} : {}}>{this.state.meter === 0 ? "Press Calclulate!" : this.state.meter+"%"}</div>
                    </div>
                </div>
                <h4 style={{marginTop:"10vh"}} className="ui header" >By: Ihsan Fajar Ramadhan</h4>
                </div>
                </div>
                </div>
            );
        }
    }
}

export default Decision;